import { render, staticRenderFns } from "./DateValid.vue?vue&type=template&id=580fd360&"
import script from "./DateValid.vue?vue&type=script&lang=js&"
export * from "./DateValid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports